<template>
    <div>
        <Title title="关于我们" path="/my"/>

        <div class="abbox">
            <div class="abnav">
                <router-link to="/about" class="curr">关于我们</router-link>
                <router-link to="/mianze">免责声明</router-link>
                <router-link to="/treaty">用户协议</router-link>
                <router-link to="/contact">联系我们</router-link>
            </div>
            <div class="abright">
                <div class="abmain">
<!--                    <div class="title"><span>关于我们</span><em>/About US</em><i></i></div>-->
                    <img :src="banner" class="banner" />
                    <div class="con">
                        烽行体育网站主要为众多彩民而打造的一款竞彩专家推荐为特色的足球、篮球赛事分析类平台。烽行体育专注为广大网友提供足球、篮球等体育界新闻资讯、即时比分、赛事推介等信息，满足广大用户对体育方面的资讯需求。
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Title from '../public/title'
    import banner from '../../assets/images/banner1.jpg'
    export default {
        name: "about",
        components: {
          Title
        },
        data() {
            return {
                banner: banner
            }
        },
        activated() {
            this.$backTop()
        },
        methods: {
        },
    }
</script>

<style scoped>
</style>
